import { LOAD_PRODUCTS } from '../actions/productActions'

export default function (state = null, action) {
  switch (action.type) {
    case LOAD_PRODUCTS:
      return { ...state, products: action.payLoad }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/productReducers.js